import { render } from "./OurProcess.vue?vue&type=template&id=4681c2c4&scoped=true"
import script from "./OurProcess.vue?vue&type=script&lang=js"
export * from "./OurProcess.vue?vue&type=script&lang=js"

import "./OurProcess.vue?vue&type=style&index=0&id=4681c2c4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4681c2c4"]])

export default __exports__